import { render, staticRenderFns } from "./live-requests-card.vue?vue&type=template&id=40fc9546&scoped=true&"
import script from "./live-requests-card.vue?vue&type=script&lang=js&"
export * from "./live-requests-card.vue?vue&type=script&lang=js&"
import style0 from "./live-requests-card.vue?vue&type=style&index=0&id=40fc9546&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fc9546",
  null
  
)

export default component.exports